<template>
  <div
    v-if="Subscription.InEditMode"
    class="d-flex flex-column mt-sm-5 pt-sm-5 mt-xxs-3 pt-xxs-3 px-sm-5 px-xxs-2 mx-sm-5 mx-xxs-3 justify-content-center align-items-center"
  >
    <a
      href="#"
      class="text-dark text-decoration-none align-self-start align-content-center my-3 mx-5 lead"
      @click="SetSubscriptionMode(false)"
    >
      <img height="30" class="bidi-icon" src="@/assets/icons/back.svg">
      {{ $t('common.back') }}
    </a>
    <UserProfileNewUserSubscriptions
      :subscription-plans="SubscriptionPlans"
      @SelectPlan="SelectPlan"
    />
  </div>
  <main
    v-else
    class="remove-body-top-padding vh-100-auto d-flex flex-column justify-content-center mx-auto col-xxl-5 col-xl-6 col-lg-7 col-md-8 col-sm-7 col-xxs-12 px-0"
  >
    <BuySubscriptionFactorForm
      :footer="Footer"
      :payment="Payment"
      :accounting="Accounting"
      :subscription="Subscription"
      @ToggleDiscountCode="ToggleDiscountCode"
      @SetSubscriptionMode="SetSubscriptionMode"
      @applyDiscountCodeStore="applyDiscountCodeStore"
      @checkoutToBankStore="checkoutToBankStore"
    />
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserProfileNewUserSubscriptions from '@/components/UserProfileNewUserSubscriptions.vue'
import BuySubscriptionFactorForm from '@/components/BuySubscriptionFactorForm.vue'

export default {
  name: 'BuySubscriptionFactor',
  components: {
    UserProfileNewUserSubscriptions,
    BuySubscriptionFactorForm
  },
  data () {
    return {
      selectedPlan: {},
      Footer: {
        Date: new persianDate(new Date()).format('L')
      },
      Payment: {
        User: {

        },
        Price: {
          Value: '',
          Discount: {
            Discount: '',
            Price: '',
            InEditMode: false
          },
          Total: '',
          Unit: ''
        },
        VAT: {
          Price: '',
          Percent: '',
          Unit: ''
        }
      },
      SubscriptionData: {
        // Title: "اشتراک ماهیانه",
        // SubscriptionTime: "یک ماه",
        // Accent: "secondary",
        // LightAccent: "secondary-light",
        // Icon: "/img/ps-left.svg",
        // InEditMode: false
      },
      AccountingData: {
        CurrentBalance: '',
        Unit: 'تومان'
      },
      SubscriptionPlansData: [
        // {
        //   Icon: "/img/ps-top.svg",
        //   Title: "اشتراک سالانه",
        //   Price: 180000,
        //   Description: "",
        //   Discount: 20,
        //   Accent: "success-light",
        //   TextAccent: "success",
        //   SubscriptionTime: "دوازده ماه",
        //   Unit: "تومان",
        //   DiscountedPrice: 180000 - (180000 * 20) / 100,
        //   Type: "Yearly"
        // },
        // {
        //   Icon: "/img/ps-left.svg",
        //   Title: "اشتراک ماهیانه",
        //   Price: 15000,
        //   Description: "",
        //   Discount: 10,
        //   Accent: "secondary-light",
        //   TextAccent: "secondary",
        //   SubscriptionTime: "یک ماه",
        //   Unit: "تومان",
        //   DiscountedPrice: 15000 - (15000 * 10) / 100,
        //   Type: "Monthly"
        // },
        // {
        //   Icon: "/img/ps-right.svg",
        //   Title: "اشتراک هفتگی",
        //   Price: 500,
        //   Description: "",
        //   Discount: "",
        //   Accent: "warning-light",
        //   TextAccent: "warning",
        //   SubscriptionTime: "یک هفته",
        //   Unit: "تومان",
        //   Type: "Weekly"
        // },
        // {
        //   Icon: "/img/ps-bottom.svg",
        //   Title: "اشتراک روزانه",
        //   Price: 500,
        //   Description:
        //     "هزینه این نوع اشتراک را با شارژ تلفن همراه پرداخت خواهید کرد. تا هنگامیکه اشتراک را لغو نکنید، مشترک خواهید ماند",
        //   Discount: "",
        //   Accent: "primary-light",
        //   TextAccent: "primary",
        //   SubscriptionTime: "",
        //   Unit: "تومان",
        //   Type: "Daily"
        // }
      ]
    }
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config',
      subscriptionPlan: 'order/subscriptionPlan',
      SubscriptionPlans: 'order/subscriptionPlans',
      Subscription: 'order/subscription',
      Accounting: 'order/accounting',
      // Payment: "order/payment",
      userInfo: 'userDemographic/userInfo',
      userBasket: 'order/userBasket',
      userOrderCode: 'order/userOrderCode'
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  },
  methods: {
    ...mapActions({
      setSubscriptionPlans: 'order/setSubscriptionPlans',
      setSubscription: 'order/setSubscription',
      setAccounting: 'order/setAccounting',
      setPayment: 'order/setPayment',
      loadUserInfo: 'userDemographic/loadUserInfo',
      addToBasket: 'order/addToBasket',
      applyDiscountCode: 'order/applyDiscountCode',
      checkoutToBank: 'order/checkout',
      pay: 'order/pay'
    }),
    SetInitialData () {
      if (this.userInfo.username === undefined) {
        this.loadUserInfo().then(response => {
          this.Payment.User = {
            FirstName: response.body.result.firstName !== undefined ? response.body.result.firstName : '',
            LastName: response.body.result.lastName !== undefined ? response.body.result.lastName : '',
            Biography: response.body.result.bio !== undefined ? response.body.result.bio : '',
            UserName: response.body.result.username !== undefined ? response.body.result.username : '',
            Nickname: response.body.result.nickName !== undefined ? response.body.result.nickName : '',
            DateOfBirth: response.body.result.birthDate !== undefined ? response.body.result.birthDate : '',
            Gender: '',
            Cellphone: response.body.result.phoneNumber
              ? response.body.result.phoneNumber
              : '',
            Email: response.body.result.email ? response.body.result.email : ''
            // FullName: response.body.result.firstName + " " + response.body.result.lastName
          }
        })
      } else {
        this.Payment.User = {
          FirstName: this.userInfo.firstName !== undefined ? this.userInfo.firstName : '',
          LastName: this.userInfo.lastName !== undefined ? this.userInfo.lastName : '',
          Biography: this.userInfo.bio !== undefined ? this.userInfo.bio : '',
          UserName: this.userInfo.username !== undefined ? this.userInfo.username : '',
          Nickname: this.userInfo.nickName !== undefined ? this.userInfo.nickName : '',
          DateOfBirth: this.userInfo.birthDate !== undefined ? this.userInfo.birthDate : '',
          Gender: '',
          Cellphone: this.userInfo.phoneNumber !== undefined ? this.userInfo.phoneNumber : '',
          Email: this.userInfo.email !== undefined ? this.userInfo.email : ''
          // FullName: this.userInfo.firstName + " " + this.userInfo.lastName
        }
      }
      this.Payment.User.FullName = this.Payment.User.FirstName + ' ' + this.Payment.User.LastName
      if (this.Payment.User.FullName === ' ') {
        this.Payment.User.FullName = this.Payment.User.Nickname
      }
    },
    ToggleDiscountCode () {
      this.Payment.Price.Discount.InEditMode = !this.Payment.Price.Discount
        .InEditMode
    },
    SetSubscriptionMode (state) {
      this.Subscription.InEditMode = state
    },
    SelectPlan (plan) {
      this.selectedPlan = plan
      this.setSubscriptionInStore()
      this.setPaymentInStore()
      this.addToBasketStore(plan)
    },
    getSubscription () {
      var subscription = {
        Title: this.selectedPlan.Title,
        Icon: this.selectedPlan.Icon,
        Accent: this.selectedPlan.TextAccent,
        LightAccent: this.selectedPlan.Accent,
        InEditMode: false,
        SubscriptionTime: this.selectedPlan.SubscriptionTime
      }
      return subscription
    },
    setSubscriptionInStore () {
      var subscription = this.getSubscription()
      this.setSubscription(subscription)
    },
    getPayment () {
      var payment = {
        User: this.getCurrentUser(),
        Price: this.getPrice(),
        VAT: this.getVAT()
      }
      return payment
    },
    setPaymentInStore () {
      var payment = this.getPayment()
      this.Payment = payment
      this.setPayment(payment)
    },
    getCurrentUser () {
      return this.Payment.User
    },
    getPrice () {
      var price = {
        Value: this.selectedPlan.Price,
        Total: this.calculateTotalPrice(),
        Unit: this.selectedPlan.Unit,
        Discount: this.calculateDiscount()
      }
      return price
    },
    calculateDiscount () {
      var discount = {
        Price: this.calculateDiscountPrice(),
        InEditMode: false,
        Discount: this.selectedPlan.Discount
      }
      return discount
    },
    getVAT () {
      var vat = {
        Percent: this.Payment.VAT.Percent,
        Unit: this.Payment.VAT.Unit,
        Price: this.calculateVATPrice()
      }
      return vat
    },
    calculateTotalPrice () {
      var totalPrice = this.discountedPrice() + this.calculateVATPrice()
      return totalPrice
    },
    calculateVATPrice () {
      var vatPrice = Math.round(this.discountedPrice() * (this.getVatPercent() / 100))
      return vatPrice
    },
    getVatPercent () {
      var vatPercent = this.Payment.VAT.Percent ? this.Payment.VAT.Percent : 0
      return vatPercent
    },
    discountedPrice () {
      var discountedPrice =
        this.selectedPlan.Price - this.calculateDiscountPrice()
      return discountedPrice
    },
    calculateDiscountPrice () {
      var discountPrice =
        (this.selectedPlan.Price * this.selectedPlan.Discount) / 100
      return discountPrice
    },
    addToBasketStore (plan) {
      let input = {}
      input.basketCode = 0
      input.planCode = plan.PlanCode

      this.addToBasket(input).then(response => {

      })
    },
    applyDiscountCodeStore () {
      let input = {}
      input.planCode = this.selectedPlan.PlanCode
      input.basketCode = this.userBasket
      input.code = this.Payment.Price.Discount.Discount

      this.applyDiscountCode(input).then(response => {
        if (response === undefined) {
          this.$bvToast.toast(this.$t('UserProfile.Subscription.BuySubscriptionFactor.InvalidDiscountCode'), {
            title: this.$t('UserProfile.Subscription.BuySubscriptionFactor.warning'),
            autoHideDelay: 3000,
            appendToast: true,
            variant: 'warning',
            solid: true
          })
          return
        }
        this.Payment.Price.Discount.Price = response.discountAmount / 10
        this.Payment.Price.Total = response.paidAmount / 10
        this.ToggleDiscountCode()
      })
    },
    checkoutToBankStore (useCurrentBalance) {
      let input = {}
      input.basketCode = this.userBasket
      input.useCurrentBalance = useCurrentBalance
      this.checkoutToBank(input).then(response => {
        setTimeout(() => {
          window.location.href = response.body.result
        }, 1000)
      })
    }
  },
  created () {
    this.setSubscriptionPlans(this.SubscriptionPlansData)
    this.setSubscription(this.SubscriptionData)
    this.setAccounting(this.AccountingData)
    this.setPayment(this.PaymentData)
    this.SetInitialData()
  },
  mounted () {
    this.SelectPlan(this.subscriptionPlan)
    this.SetInitialData()
  }
}
</script>
